export class Column {
  property: string;
  label: string;
  type: string;
  filterable?: boolean;
  flexGrow?: number;
  valueCallback?: <T>(obj: T) => string;
}



// WEBPACK FOOTER //
// ./src/app/models/column.ts